var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9164 20.7867C12.0507 20.9238 12.2336 21 12.425 21C12.6164 21 12.7993 20.9238 12.9336 20.7867L22.0707 11.5286C24.4431 9.12571 24.4431 5.21429 22.0707 2.81048C20.9183 1.64286 19.386 1 17.7545 1C16.1231 1 14.5917 1.64286 13.4393 2.80952L12.425 3.8381L11.4107 2.81048C10.2583 1.64286 8.72595 1 7.09548 1C5.46405 1 3.93167 1.64286 2.77929 2.81048C0.406905 5.21429 0.406905 9.12571 2.77929 11.5276L11.9164 20.7867ZM3.79548 3.81333C4.67738 2.92095 5.84976 2.42857 7.09452 2.42857C8.34024 2.42857 9.51167 2.92095 10.3926 3.81429L11.9155 5.35714C12.1831 5.62857 12.664 5.62857 12.9317 5.35714L14.4545 3.81333C15.3383 2.92095 16.5098 2.42857 17.7545 2.42857C19.0002 2.42857 20.1717 2.92095 21.0536 3.81333C22.8793 5.66381 22.8793 8.67429 21.0536 10.5257L12.425 19.2695L3.79548 10.5248C1.96976 8.67524 1.96976 5.66381 3.79548 3.81333Z",
    fill: "#2C3E50",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlue);
export default __webpack_public_path__ + "static/media/heart-blue.317197d0ea81f37bacbced1cf01f25a2.svg";
export { ForwardRef as ReactComponent };